






























































































































import { defineComponent, ref, onMounted } from '@vue/composition-api'
import {
  mdiCancel,
  mdiCheckCircleOutline,
  mdiDotsVertical,
  mdiFilterVariantMinus,
  mdiPencilOutline,
  mdiPlus,
  mdiViewListOutline,
} from '@mdi/js'

// Components
import PaginationSelect from '@shared/components/PaginationSelect.vue'
import PaginationFooter from '@shared/components/PaginationFooter.vue'
import DenominacionFiltro from '../components/DenominacionFiltro.vue'
import DenominacionModal from '../components/DenominacionModal.vue'

import { IResponseElement, DenominacionFiltroModel, DenominacionInterface, Pagination } from '@/models'

import useAppConfig from '@core/@app-config/useAppConfig'
import useSweetAlert from '@core/plugins/sweetalert'
import useDenominacionEndpoint from '../composables/useDenominacionEndpoint'

export default defineComponent({
  components: {
    PaginationSelect,
    PaginationFooter,
    DenominacionFiltro,
    DenominacionModal,
  },
  setup() {
    const denominaciones = ref<DenominacionInterface[]>([])
    const denominacionSeleccionada = ref<DenominacionInterface | null>(null)
    const isFilterPanelActive = ref(false)
    const mostrarDenominacionModal = ref(false)
    const filtro = ref(new DenominacionFiltroModel())
    const pagination = ref(new Pagination())
    const { confirm, showMessage } = useSweetAlert()
    const { isLoading } = useAppConfig()
    const { deleteDenominacion, find } = useDenominacionEndpoint()

    onMounted(() => {
      obtenerDenominaciones(filtro.value)
    })

    const obtenerDenominaciones = async (filter: DenominacionFiltroModel) => {
      filtro.value = filter
      const params = { ...filtro.value, start: filtro.value.start - 1 }

      isLoading.value = true
      const { ok, response } = await find(params)

      if (ok) {
        actualizarPaginacion(response as IResponseElement<DenominacionInterface>)
      }

      isLoading.value = false
    }

    const actualizarPaginacion = (response: IResponseElement<DenominacionInterface>) => {
      denominaciones.value = response.elements
      pagination.value.setPagination(filtro.value.start, filtro.value.limit, response.totalCount)
      filtro.value.start = pagination.value.number
    }

    const editarDenominacion = (denominacion: DenominacionInterface) => {
      denominacionSeleccionada.value = denominacion
      mostrarDenominacionModal.value = true
    }

    const cambiarEstadoDenominacion = async (denominacion: DenominacionInterface) => {
      const { value } = await confirm(
        `¿Está seguro de ${denominacion.habilitado === 'S' ? 'inactivar' : 'habilitar'} la denominacion?`,
        `${denominacion.habilitado === 'S' ? 'danger' : 'success'}`,
      )

      if (value) {
        isLoading.value = true
        const { ok, response } = await deleteDenominacion(denominacion.denominacionId)

        if (ok) {
          showMessage('Éxito!', response?.mensaje, 'success')
          obtenerDenominaciones(filtro.value)
        }
        isLoading.value = false
      }
    }

    const denominacionModalOnClose = (actualizar: boolean) => {
      denominacionSeleccionada.value = null
      mostrarDenominacionModal.value = false
      if (actualizar) {
        obtenerDenominaciones(filtro.value)
      }
    }

    return {
      denominaciones,
      denominacionSeleccionada,
      denominacionModalOnClose,
      cambiarEstadoDenominacion,
      editarDenominacion,
      filtro,
      isFilterPanelActive,
      isLoading,
      mostrarDenominacionModal,
      obtenerDenominaciones,
      pagination,
      icons: {
        mdiCancel,
        mdiCheckCircleOutline,
        mdiDotsVertical,
        mdiFilterVariantMinus,
        mdiPencilOutline,
        mdiPlus,
        mdiViewListOutline,
      },
    }
  },
})
